import { GetterTree } from "vuex";
import { RootState } from "..";
import { PanelState } from "./panel.module";
import { GlobalPagination } from "@/interfaces/panel/global-pagination.model";
import { UserAcceptedAuthModel } from "@/interfaces/users/user-accepted-auth.model";
import { GetUserModel } from "@/interfaces/users/get-user.model";
import { SystemSettingsModel } from "@/interfaces/panel/system-settings.model";
import { ManualCharge, ManualChargeFilters, ManualChargePagination } from "@/interfaces/panel/manual-charge.model";
import { GatewaySettlementSettings } from "@/interfaces/panel/gateway-settlement-settings";

export const PANEL_GETTERS: GetterTree<PanelState, RootState> = {
    // get active route page
    getLoadingPanel(state): boolean {
        return state.loading;
    },
    getGlobalPagination(state): GlobalPagination {
        return state.globalPagination;
    },
    getGlobalActivePage(state): number {
        return state.globalActivePage;
    },

    // sayyarpay
    getAllUsers(state): GetUserModel[] {
        return state.allUsers;
    },

    getNotVerifiedUsers(state): GetUserModel[] {
        return state.notVerifiedUsers;
    },

    getUserInfo(state): GetUserModel {
        return state.userInfo;
    },

    getUserAcceptedAuth(state): UserAcceptedAuthModel {
        return state.userAcceptedAuth;
    },

    getSystemLogs(state): unknown[] {
        return state.systemLogs;
    },

    getUserTransactions(state): unknown[] {
        return state.userTransactions;
    },

    getExternalTransactions(state): unknown[] {
        return state.externalTransactions;
    },

    getUserExternalTransactions(state): unknown[] {
        return state.userExternalTransactions;
    },

    getAllWithdrawals(state): unknown[] {
        return state.allWithdrawals;
    },

    getUserWithdrawals(state): unknown[] {
        return state.userWithdrawals;
    },

    getSystemSettings(state): SystemSettingsModel {
        return state.systemSettings;
    },

    getGateways(state): unknown[] {
        return state.gateways;
    },

    getGatewayInfo(state): Record<string, unknown> | null {
        return state.gatewayInfo;
    },

    getGatewayTransactions(state): unknown[] {
        return state.gatewayTransactions;
    },

    getCommissions(state): unknown[] {
        return state.commissions;
    },

    getDepositTRansferHistory(state): unknown[] {
        return state.depositTransferHistory;
    },

    getGatewaySettlementSettings(state): GatewaySettlementSettings | null {
        return state.gatewaySettlementSettings;
    },

    getManualCharges(state): ManualCharge[] {
        return state.manualCharges;
    },

    getManualChargesPagination(state): ManualChargePagination {
        return state.manualChargesPagination;
    },

    getManualChargesFilters(state): ManualChargeFilters {
        return state.manualChargesFilters;
    },

    getManualChargesLoading(state): boolean {
        return state.manualChargesLoading;
    },

    getManualChargeActionLoading(state): Record<string, boolean> {
        return state.manualChargeActionLoading;
    },
    getWithdrawalscrypto(state): any[] {
        return state.withdrawalsCrypto;
    },

    getUserFinancialLogs(state): any[] {
        return state.userFinancialLogs;
    },

    getUserStatement(state) {
        return state.userStatement;
    },

    getPaymentSetting(state) {
        return state.paymentSetting;
    },

    getExchangeSetting(state) {
        return state.exchangeSetting;
    },

    getTotalTransactionsAmount(state) {
        return state.totalTransactionsAmount;
    }
};
